module.exports = __webpack_public_path__ + "static/media/omit_dropdown_icon.ae7e87e4.svg";